<template>
  <v-container ref="copyContainer" grid-list-xl fluid>
    <v-layout row wrap>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex v-if="!pageLoading">
        <filter-negatives
          :default-search-params="searchParams"
          :is-component-loading="isRequestingNow"
          @download-excel="onDownloadExcel"
          @filtering="onFilter"
        ></filter-negatives>
        <table-paginated-negatives
          :is-component-loading="isRequestingNow"
          :paginated-object="paginatedObject"
          @delete-item="onPaginatedItemDelete"
        ></table-paginated-negatives>
        <pagination-listing
          :pagination-data="paginationData"
          @go-prev="changePage('-')"
          @go-next="changePage('+')"
        ></pagination-listing>
      </v-flex>
      <modal-loading :is-show="isTableLoading"></modal-loading>
      <accept-dialog
        :is-open-dialog="isShowDeleteDialog"
        @on-close="isShowDeleteDialog=false"
        @on-accept="onAcceptDeletion"
      >
        <div class="pt-6">
          {{acceptModalText}}
        </div>
      </accept-dialog>
    </v-layout>
  </v-container>
</template>

<script>
/* constants */
import { PER_PAGE_ORDERS } from '@/constants/listing';
/* proxy */
import NegativeProxy from '@/proxies/Negative/NegativeProxy';

/* mixins */
import downloadReport from '@/mixins/reports/downloadReport';
/* components */
import PaginationListing from '@/components/listings/PaginationListing.vue';
import ModalLoading from '@/components/loaders/ModalLoading.vue';
import TablePaginatedNegatives
  from '@/components/listings/TablePaginatedNegatives.vue';
import FilterNegatives from '@/components/listings/FilterNegatives.vue';
import AcceptDialog from '@/components/AcceptDialog.vue';
import { strReplaceAll } from '@/utils';
import updatePageContentMixin from '../../mixins/updatePageContentMixin';
import paginationMixin from '../../mixins/listing/paginationMixin';
import defaultListingMixin from '../../mixins/listing/defaultListingMixin';

export default {
  name: 'Listing',
  mixins: [
    paginationMixin,
    defaultListingMixin,
    updatePageContentMixin,
    downloadReport,
  ],
  components: {
    PaginationListing,
    ModalLoading,
    TablePaginatedNegatives,
    FilterNegatives,
    AcceptDialog,
  },
  data() {
    return {
      reportMethodName: 'negativesListingReport',
      /* Page management */
      pageLoading: false,
      /* Create - Edit */
      currentEditableItem: {},
      /* Delete */
      isShowDeleteDialog: false,
      /* Listing management */
      isTableLoading: false,
      searchParams: {
        page: {
          number: 1,
          size: PER_PAGE_ORDERS,
        },
        search_contact: '',
      },
    };
  },
  created() {
    this.isTableLoading = true;
  },
  computed: {
    /* edit modal */
    orderDialogActionLabel() {
      if (this.isShowOrderDialog) {
        return (this.currentEditableItem.uuid)
          ? this.lang(this.$store, 'sap/listings.global.edit.save')
          : this.lang(this.$store, 'sap/listings.global.edit.create');
      }
      return '';
    },
    /* accept modal */
    acceptModalText() {
      return strReplaceAll(this.lang(this.$store, 'sap/listings.global.delete.question'), {
        user: (this.currentEditableItem.order) ? this.currentEditableItem.order.datetime : '',
      });
    },
  },
  methods: {
    fetchData() {
      this.isRequestingNow = true;
      new NegativeProxy()
        .setParameters(this.searchParams)
        .all()
        .then((response) => {
          this.paginatedObject = response.data.data.negatives;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.warn(error);
          this.paginatedObject = {};
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },

    onAcceptDeletion() {
      this.isRequestingNow = true;
      new NegativeProxy().destroy(this.currentEditableItem.uuid)
        .catch((response) => {
          console.error(response);
          alert(`Error: ${response.status}`);
          this.isRequestingNow = false;
        })
        .then(() => {
          this.fetchData();
        });
    },
    onPaginatedItemDelete(item) {
      this.currentEditableItem = item;
      this.isShowDeleteDialog = true;
    },
  },
};
</script>

<style scoped>

</style>
